import { IGanadorWithData } from '../consejeros/types/ganadores'

export const singleGanadorWithData: IGanadorWithData = {
  cargo_publico: '',
  circunscripcion: '7',
  edad: 35,
  genero: 'm',
  id: '',
  lista: '',
  nombre_completo: '',
  partido: '',
  photo_path: '',
  porcentaje: 0,
  votos: 0,
}

export const emptyGanadoresWithData: IGanadorWithData[] = Array(50)
  .fill(singleGanadorWithData)
